import { useEffect, useRef, useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import Loader from "../component/Loader";
import MessageToster from "../component/MessageToster";
import axios from "axios";
import { BASE_URL } from "../api";
import { closeModal } from "../utils/modal";
import { useHandleError } from "../hooks/useHandleError";
import { getApiHeaders } from "../utils/helpers";
import { getAuthToken } from "../token";
import Cookies from "js-cookie";
import { exportToExcel } from "../utils/exportData";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import CommonTable from "../component/CommonTable";
import ExportButton from "../component/ExportButton";
import MobileFilter from "../component/MobileFilter";

export default function LiveAccount() {
  const token = getAuthToken();
  const handleError = useHandleError();
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    platform: "",
    account_group: "",
    leverage: "",
  })
  const [validations, setValidations] = useState({
    platform: "",
    account_group: "",
    leverage: "",
  });
  const validationRules = {
    platform: "Platform is required.",
    account_group: "Account type is required.",
    leverage: "Leverage is required.",

  };

  const handleReset = () => {
    setInput({
      platform: "",
      account_group: "",
      leverage: ""
    });

    setValidations({
      platform: "",
      account_group: "",
      leverage: "",
    });
  }

  const [kycStatus, setKycStatus] = useState(null);

  const handleDashboardClick = (accountNumber) => {
    sessionStorage.setItem("live_account_no", accountNumber);
    window.location.href = "/live_account_dashboard";
  };

  const handleAccountTradesClick = (account_number) => {
    sessionStorage.setItem("selected_account", account_number);
    window.location.href = "/trade_history";
  };


  const handelChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
    setValidations((prev) => ({ ...prev, [name]: "" }));
    // setInput({ ...input, [name]: value });
    // setValidations({ ...validations, [name]: false });
  };
  const [accountType, setAccountType] = useState([]);

  const getaccounttypes = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/MT5M/get_mt5_groups_for_user`, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        const data = res.data.data;
        const groups = Array.isArray(data) ? data : [data];

        setAccountType(groups);
      } else {
        MessageToster('error', res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const onSubmitForm = async () => {
    const newValidations = {};
    let hasError = false;

    Object.keys(validationRules).forEach((field) => {
      if (!input[field]) {
        newValidations[field] = validationRules[field];
        hasError = true;
      } else {
        newValidations[field] = "";
      }
    });

    setValidations(newValidations);
    if (hasError) return;
    await createLiveAccount();

    // for (const field in input) {
    //   if (!input[field]) {
    //     newValidations[field] = true;
    //     hasError = true;
    //   } else {
    //     newValidations[field] = false;
    //   }
    // }
  };

  const createLiveAccount = async () => {
    const mid = sessionStorage.getItem("mid");

    const bodyData = {
      // mid: Number(mid),
      trading_platform: input.platform,
      currency: "USD",
      account_group: input.account_group,
      leverage: Number(input.leverage),
      account_type: "LIVE"
    };

    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/MT5M/create_new_real_account`, bodyData, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        setInput({
          platform: "",
          account_group: "",
          leverage: ""
        });
        MessageToster("success", res.data.message);
        handleReset();
        getTabelData();
        closeModal();
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const checkKycStatus = async () => {
    const mid = sessionStorage.getItem("mid");

    setLoading(true);

    // const inputBody = {
    //   mid: Number(mid)
    // };

    try {
      const res = await axios.get(`${BASE_URL}/kyc/kyc_approve_or_reject_status`, { headers: getApiHeaders() });
      if (res.data.code === 200) {
        const status = res.data.data?.status || 'Pending';
        setKycStatus(status);
        // setKycStatus("Approve");
        // console.log(status)
      }
      else {
        setKycStatus("NotSubmitted");
        MessageToster("error", res.data.message || "Failed to fetch KYC status.");
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        setKycStatus("NotSubmitted");
      } else {
        handleError(error);
        MessageToster("error", "Something went wrong");
      }

    } finally {
      setLoading(false);
    }
  };

  const [accountData, setAccountData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });

  const clearFilters = () => {
    setFilters({
      fromDate: "",
      toDate: "",
    });
    setSearchTerm("");
    setFilteredData(accountData);
  };

  useEffect(() => {
    setFilteredData(accountData);
  }, [accountData]);

  const handleSearch = () => {
    let data = [...accountData];
    if (filters.fromDate) {
      const from = new Date(filters.fromDate);
      from.setHours(0, 0, 0, 0);
      data = data.filter((item) => {
        const itemDateStr = item.create_date ? item.create_date.split('.')[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate >= from;
      });
    }
    if (filters.toDate) {
      const to = new Date(filters.toDate);
      to.setHours(23, 59, 59, 999);
      data = data.filter((item) => {
        const itemDateStr = item.create_date ? item.create_date.split('.')[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate <= to;
      });
    }
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      data = data.filter((item) => {
        return (
          String(item.account_number || "").toLowerCase().includes(searchLower) ||
          String(item.account_group || "").toLowerCase().includes(searchLower) ||
          String(item.leverage || "").toLowerCase().includes(searchLower) ||
          String(item.margin_free || "").toLowerCase().includes(searchLower) ||
          String(item.balance || "").toLowerCase().includes(searchLower)
        );
      });
    }
    setFilteredData(data);
  };

  const getTabelData = async () => {
    const mid = sessionStorage.getItem('mid');

    // const bodyData = {
    //   mid: Number(mid),
    //   mode: ""
    // }

    setLoading(true);

    try {
      const res = await axios.get(`${BASE_URL}/MT5M/user_real_accounts_list`, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        setAccountData(res.data.data || []);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   checkKycStatus();
  //   getaccounttypes()
  //   getTabelData()
  // }, []);

  useEffect(() => {
    checkKycStatus();
  }, []);

  useEffect(() => {
    if (kycStatus === "Approved") {
      getaccounttypes();
      getTabelData();
    }
  }, [kycStatus]);

  // useEffect(() => {
  //   if (accountData?.length > 0) {
  //     const rows = accountData.map((acc) => [
  //       acc.account_number,
  //       acc.trading_platform,
  //       acc.account_type,
  //       acc.leverage,
  //       acc.currency,
  //       acc.create_date ? dayjs(acc.create_date).format("DD-MM-YYYY") : "",
  //       acc.istatus,
  //       "",
  //     ]);
  //     displayButtons(tableRef, rows);
  //   }
  // }, [accountData]);



  const isApprove = kycStatus === "Approved";
  const isReject = kycStatus === "Reject";
  const isPending = kycStatus === "Pending";
  const isExpire = kycStatus === "Expire";
  const isNotSubmitted = kycStatus === "NotSubmitted";


  return (
    <>
      <div id="layout-wrapper">
        {loading &&
          <Loader />
        }
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            {isPending && (
              <div className="row justify-content-center">
                <div
                  className="alert alert-warning alert-dismissible fade show"
                  role="alert"
                  style={{
                    backgroundColor: "#fff3cd",
                    borderColor: "#ffeeba",
                    color: "#856404",
                    marginBottom: "1.5rem",
                  }}
                >
                  <i className="mdi mdi-timer-sand-full me-2" />
                  Please complete your KYC process. Once your verification is approved, you will be able to open a live account on MT5.
                </div>

                {/* <div className="col-xl-5 col-lg-6 col-md-8 col-12">
                  <div className="card">
                    <div className="card-body text-center">
                      <img
                        src="assets/images/ib/overview.webp"
                        alt=""
                        width="280px"
                      />
                      <p className="fw-bold text-warning">
                        IB Application Submitted
                      </p>
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                      >
                        Application Pending Review
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            )}

            {isReject && (
              <div className="row justify-content-center">
                <div
                  className="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  style={{
                    backgroundColor: "#f8d7da",
                    borderColor: "#f5c6cb",
                    color: "#856404",
                    marginBottom: "1.5rem",
                  }}
                >
                  <i className="mdi mdi-close-octagon-outline me-2" />
                  Your KYC application has been **rejected**. Please check your email for details regarding the required documents or information, and re-submit your application.
                </div>

              </div>
            )}
            {isApprove && (
              <>
                <div className="container-fluid">
                  {/* start page title */}
                  <div className="row">
                    <div className="col-12">
                      <div className="page-title-box d-flex align-items-center justify-content-between">
                        <h2 className="fw-700 mb-0">Live Account</h2>
                        <div className="live_account_btn">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            data-bs-toggle="modal"
                            data-bs-target=".bs-example-modal-center"
                            onClick={handleReset}
                          >
                            Open Account
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end page title */}
                  <div className="row">
                    <div className="col-12">
                      <div className="card" style={{ minHeight: "calc(100vh - 210px)" }}>
                        <div className="card-body liveaccount_body d-flex flex-column">
                          <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                            <div>
                              <label htmlFor="">From</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                name="fromDate"
                                value={filters.fromDate}
                                onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                                max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                                id="example-date-input"
                              />
                            </div>
                            <div>
                              <label htmlFor="">To</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                name="toDate"
                                value={filters.toDate}
                                onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                                min={filters.fromDate || undefined}
                                max={new Date().toISOString().split("T")[0]}
                                id="example-date-input"
                              />
                            </div>
                            <div>
                              <label htmlFor="">Search</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={handleSearch}
                              >
                                Search
                              </button>
                            </div>
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={clearFilters}
                                disabled={!filters.fromDate && !filters.toDate && !searchTerm}
                              >
                                Clear
                              </button>
                            </div>
                            <div className="ms-auto">
                              <ExportButton
                                disabled={!filteredData || filteredData.length === 0}
                                onClick={() => exportToExcel(filteredData, "live_account", "live_account")}
                              />
                            </div>
                          </div>

                          <MobileFilter
                            title="History"
                            onExport={() => exportToExcel(filteredData, "live_account", "live_account")}
                            exportDisabled={!filteredData || filteredData.length === 0}
                          >
                            <div>
                              <label htmlFor="">From</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                name="fromDate"
                                value={filters.fromDate}
                                onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                                max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                              />
                            </div>
                            <div>
                              <label htmlFor="">To</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                name="toDate"
                                value={filters.toDate}
                                onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                                min={filters.fromDate || undefined}
                                max={new Date().toISOString().split("T")[0]}
                              />
                            </div>
                            <div>
                              <label htmlFor="">Search</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            <div className="d-flex gap-2 mt-2">
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light flex-grow-1"
                                onClick={handleSearch}
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#filterOffcanvasMobile"
                              >
                                Search
                              </button>
                              <button
                                type="button"
                                className="btn btn-light waves-effect waves-light border flex-grow-1"
                                onClick={clearFilters}
                                disabled={!filters.fromDate && !filters.toDate && !searchTerm}
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#filterOffcanvasMobile"
                              >
                                Clear
                              </button>
                            </div>
                          </MobileFilter>
                          <CommonTable
                            columns={[
                              { header: "Account No", accessor: "account_number" },
                              { header: "Platform", accessor: "trading_platform" },
                              { header: "Account Type", accessor: "account_type" },
                              { header: "Leverage", accessor: "leverage" },
                              { header: "Currency", accessor: "currency" },
                              { header: "Date", render: (row) => row.create_date ? formatDateDDMMYYYY(row.create_date) : "" },
                              { header: "Status", accessor: "istatus" },
                              {
                                header: "Actions",
                                headerStyle: { width: "1%", whiteSpace: "nowrap" },
                                style: { width: "1%", whiteSpace: "nowrap" },
                                render: (row, index, meta) => {
                                  const isLastTwo = meta?.isLastTwo ?? (
                                    filteredData && filteredData.length > 1
                                      ? (index >= filteredData.length - 2)
                                      : true
                                  );

                                  return (
                                    <div className={`btn-group ${isLastTwo ? "dropup" : ""}`}>
                                      <button
                                        type="button"
                                        className="btn btn-primary dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        data-bs-boundary="viewport"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        Actions <i className={`mdi ${isLastTwo ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                      </button>
                                      <div className="dropdown-menu dropdown-menu-end table_dropdown">
                                        <button className="dropdown-item" onClick={() => handleDashboardClick(row.account_number)}>Live Account Dashboard</button>
                                        <a className="dropdown-item" href="/leverage_history">Leverage Management</a>
                                        <a className="dropdown-item" href={`/masterpassword?account=${row.account_number}&type=live`}>Change Trading Password</a>
                                        <a className="dropdown-item" href={`/investorpassword?account=${row.account_number}&type=live`}>Change Investor Password</a>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            ]}
                            data={filteredData || []}
                            loading={loading}
                            containerStyle={{ overflow: "visible" }}
                            className="flex-grow-1 d-flex flex-column justify-content-between"
                          />
                        </div>
                      </div>
                    </div>{" "}
                    {/* end col */}
                    <div>
                      {/* modal */}
                      <div
                        className="modal fade bs-example-modal-center"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Open Live Account</h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              />
                            </div>
                            <div className="modal-body">
                              <div className="row">
                                <div className="col-12 mb-3">
                                  <div>
                                    <label className="form-label">
                                      Trading Plateform
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-select"
                                      id="platform"
                                      name="platform"
                                      value={input.platform}
                                      onChange={(e) => handelChange(e)}
                                    >
                                      <option value={""} disabled hidden>Select Your Trading Platform</option>
                                      <option value="MT5">MT5</option>
                                    </select>
                                    {validations.platform && (
                                      <p className="text-danger">{validations.platform}</p>
                                    )}
                                    {/* {validations.platform && (
                                      <p className="text-danger mb-0">{validationRules.platform}</p>
                                    )} */}
                                  </div>
                                </div>
                                <div className="col-12 mb-3">
                                  <div>
                                    <label className="form-label">
                                      Account Type{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-select"
                                      id="account_group"
                                      name="account_group"
                                      value={input.account_group}
                                      onChange={(e) => handelChange(e)}
                                    >
                                      <option value="" disabled hidden>Select account type</option>
                                      {accountType &&
                                        accountType.map((i) => (
                                          <option key={i.id} value={i.GroupName}>
                                            {i.group_name}
                                          </option>
                                        ))}

                                      {/* {accountType &&
                                    accountType.map((i, index) => (
                                      <option key={index} value={i}>
                                        {i}
                                      </option>
                                    ))} */}
                                    </select>
                                    {validations.account_group && (
                                      <p className="text-danger">{validations.account_group}</p>
                                    )}
                                    {/* {validations.account_group && (
                                      <p className="text-danger mb-0">{validationRules.account_group}</p>
                                    )} */}
                                    {/* {validations.account_group &&
                                  verror && <>
                                    <p className='text-danger mb-0'>{verror}</p>
                                  </>
                                } */}
                                  </div>
                                </div>
                                {/* <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Currency<span className="text-danger">*</span>
                                </label>
                                <select className="form-select" name="select">
                                  <option value={0}>Select an Option</option>
                                  <option value="Septa-STD-CRM-DEMO">
                                    Septa-STD-CRM-DEMO
                                  </option>
                                  <option value="Septa-VIP-CRM-DEMO">
                                    Septa-VIP-CRM-DEMO
                                  </option>
                                  <option value="Septa-ECN-CRM-DEMO">
                                    Septa-ECN-CRM-DEMO
                                  </option>
                                </select>
                              </div>
                            </div> */}
                                <div className="col-12 mb-3">
                                  <div>
                                    <label className="form-label">
                                      Leverage
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-select"
                                      name="leverage"
                                      id="leverage"
                                      value={input.leverage}
                                      onChange={(e) => handelChange(e)}
                                    >
                                      <option value={""} disabled hidden>Select leverage</option>
                                      <option value="100">100</option>
                                      <option value="200">200</option>
                                      <option value="300">300</option>
                                      <option value="400">400</option>
                                      <option value="500">500</option>
                                    </select>
                                    {/* {validations.leverage && (
                                      <p className="text-danger mb-0">{validationRules.leverage}</p>
                                    )} */}
                                    {validations.leverage && (
                                      <p className="text-danger">{validations.leverage}</p>
                                    )}
                                    {/* {validations.leverage &&
                                  verror && <>
                                    <p className='text-danger mb-0'>{verror}</p>
                                  </>
                                } */}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => {
                                  setInput({ account_group: "", leverage: "" });
                                  setValidations({});
                                }}
                              >
                                Reset
                              </button>
                              <button type="button"
                                className="btn btn-primary"
                                // data-bs-dismiss="modal"
                                // aria-label="Close"
                                onClick={onSubmitForm}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                          {/* /.modal-content */}
                        </div>
                        {/* /.modal-dialog */}
                      </div>
                      {/* /.modal */}
                    </div>
                  </div>
                </div>
              </>
            )}

            {isExpire && (
              <div className="row justify-content-center">
                <div
                  className="alert alert-warning alert-dismissible fade show"
                  role="alert"
                  style={{
                    backgroundColor: "#ff8b8bff",
                    borderColor: "#ffeeba",
                    color: "#721c24",
                    marginBottom: "1.5rem",
                  }}
                >
                  <i className="mdi mdi-timer-sand-full me-2" />
                  Your KYC has <b>expired</b>. Please complete the KYC verification process to continue. Once your verification is approved, you will be able to open a live MT5 account.</div>
              </div>
            )}
            {isNotSubmitted && (
              <div className="row justify-content-center">
                <div
                  className="alert alert-warning alert-dismissible fade show"
                  role="alert"
                  style={{
                    backgroundColor: "#fff3cd",
                    borderColor: "#ffeeba",
                    color: "#856404",
                    marginBottom: "1.5rem",
                  }}
                >
                  <i className="mdi mdi-timer-sand-full me-2" />
                  It looks like you haven’t submitted your KYC yet. Please upload your KYC details to begin verification.</div>
              </div>
            )}
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div >
    </>
  );
}
